module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn",
    class: _vm.cls,
    attrs: {
      "data-color": _vm.color
    },
    on: {
      "mousedown": function($event) {
        return _vm.doRipple($event)
      }
    }
  }, [(_vm.iconL) ? _c('span', {
    staticClass: "icon-l"
  }, [_vm._v(_vm._s(_vm.iconL))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.iconR) ? _c('span', {
    staticClass: "icon-r"
  }, [_vm._v(_vm._s(_vm.iconR))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ripple",
    style: (_vm.rippleStyle())
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b3e174","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Btn.vue
// module id = 596
// module chunks = 1